module.exports = __webpack_public_path__ + "static/abundance-337415d7965e2bc74fb9c966b09ff88c.jpg";